module.exports = __webpack_public_path__ + "static/media/IMG_4418.388f76c9.JPG";